























import { Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import PlanLimitsMixin from '@/components/ui/mixins/plan-limits-mixin';

@Component
export default class BotFilterMarks extends mixins(PlanLimitsMixin) {
  @Prop() conditions: any;
  value: string = 'IS_NOT_WEB_VIEW';
  predicate: string = 'EQUALS';

  @Watch('conditions', {
    immediate: true
  })
  onConditionsChanged(value: any, oldValue: any) {
    if(!value.webViewMark) {
      this.$set(this.conditions, 'webViewMark', {
        predicate: 'EQUALS',
        values: 'IS_NOT_WEB_VIEW'
      });
    }
  }

  @Watch('value')
  onValueChanged(value: string, oldValue: string) {
    this.$set(this.conditions.webViewMark, 'values', value);
  }

  @Watch('predicate')
  onPredicateChanged(value: string, oldValue: string) {
    this.$set(this.conditions.webViewMark, 'predicate', value);
  }

  mounted() {
    this.value = this.conditions.webViewMark.values;
  }

}
